<template>
	<div class="container">
		<transition name="el-zoom-in-top">
			<el-result v-show="show1" icon="error">
				<template #title>
					<div style="overflow: hidden;">
						<!-- 逐字显示 -->
						<span v-for="(char, index) in displayedText" :key="index">
							<transition name="el-fade-in-linear">
								<span style="font-size: 2.4rem;" v-show="char.visible">{{ char.value }}</span>
							</transition>
						</span>
					</div>
				</template>

				<template #subTitle>
					<transition name="el-zoom-in-bottom">
						<div v-show="show3" class="el-result__subtitle">
							<p style="font-size: 1.4rem;">QAQ</p>
							<p style="font-size: 1.4rem;">原因：{{msg}}</p>
						</div>
					</transition>
				</template>
			</el-result>
		</transition>
	</div>
</template>

<script>
	import {
		test_one
	} from "@/api/api.js";
	export default {
		data() {
			return {
				show1: false,
				show2: false,
				show3: false,
				text: '开锁失败',
				displayedText: [], // 每个字的状态 { value: '开', visible: false }
				intervalTime: 300, // 每个字间隔时间（毫秒）
				msg: ''
			};
		},
		mounted() {
			setTimeout(() => {
				this.show1 = true;
			}, 1000);

			setTimeout(() => {
				this.initTextDisplay(); // 开始逐字显示
			}, 1500); // 延迟开始动画

			setTimeout(() => {
				this.show3 = true;
			}, 3000);
			test_one().then(res => {
				// console.log(res);
				this.msg = res.msg
			})
		},
		methods: {
			initTextDisplay() {
				const chars = this.text.split('');
				this.displayedText = chars.map((char) => ({
					value: char,
					visible: false
				}));

				chars.forEach((_, index) => {
					setTimeout(() => {
						this.displayedText[index].visible = true;
					}, index * this.intervalTime);
				});
			},

		}
	};
</script>

<style scoped>
	.container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
	}

	.el-zoom-in-bottom-enter-active {
		transition: all 0.5s ease;
		transform-origin: center;
	}
</style>